import React, { Component } from 'react';
import { ReactComponent as OpenIcon } from './fullscreen-open.svg';
import { ReactComponent as CloseIcon } from './fullscreen-close.svg';

export const SCROLLABLE = "scrollable";

// component for the fullscreen option
// there's no state, but it uses lifecycle method `forceUpdate`
export default class FullScreenButton extends Component {

  constructor(props) {
    super(props);
    this.state = { elem: this.props.elem.current || document.body };
    document.addEventListener("fullscreenchange", this.fullScreenChangeHandler.bind(this));
  }

  fullScreenChangeHandler() {
    this.forceUpdate();
    if (document.fullscreenElement) {
      this.state.elem.classList.add(SCROLLABLE);
      return;
    }
    this.state.elem.classList.remove(SCROLLABLE);
  }

  // adapted from https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
  toggleFullScreen() {
    if (!document.fullscreenElement) {
      this.state.elem.requestFullscreen();
      return;
    } 
    document.exitFullscreen && document.exitFullscreen(); 
  }

  render() {
    const imperative = document.fullscreenElement ? "close" : "open";
    const FsIcon = document.fullscreenElement ? CloseIcon : OpenIcon;
    return (
        <div className="fullscreenButton" 
          onClick={this.toggleFullScreen.bind(this)} 
          title={`Toggle full screen mode ${imperative}`}
          alt={`Toggle full screen mode ${imperative}`}>
        <FsIcon />
        </div>
    )
  }
}